import { render, staticRenderFns } from "./wifi-install-config-device.vue?vue&type=template&id=1275cabe&scoped=true&"
import script from "./wifi-install-config-device.js?vue&type=script&lang=js&"
export * from "./wifi-install-config-device.js?vue&type=script&lang=js&"
import style0 from "./wifi-install-config-device.css?vue&type=style&index=0&id=1275cabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1275cabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText})
